import { OneGateLogo_3Icon } from "@dataone/icons";
import { styled } from "styled-components";
interface FinalStepProps {
  formMode?: "update" | "create";
}

export const FinalStep = ({ formMode }: FinalStepProps) => {
  return (
    <StyledFinalStep>
      <StyledSuccessIcon>
        <OneGateLogo_3Icon />
      </StyledSuccessIcon>
      <h3>
        Your datasource was <br />{" "}
        {formMode === "update" ? "updated" : "created"} successfully
      </h3>
    </StyledFinalStep>
  );
};

const StyledFinalStep = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 15%;
  // width: 40vw;

  h3 {
    text-align: center;
  }
`;

const StyledSuccessIcon = styled.div`
  font-size: 100px;
  color: #70bf42;
  display: flex;
`;
